export default __webpack_public_path__ + "static/media/facebookLight.5c60e23b.svg";